export const AMAZONIAN = "AMAZONIAN";
export const ITSE = "ITSE";
export const STANDARD = "standard";
export const AMZNHAM = "amznham";
export const PROCUREMENT = "procurement";

/**
 * URL for filing bug reports via t.corp ticket template
 */
export const BUG_REPORT_URL = "https://t.corp.amazon.com/create/templates/8d46d22c-fd8e-4362-b948-ac261854eff0";

export const SUPPORT_MESSAGES_LABELS = {
  PENDING: "Pending",
  UP_TO_DATE: "Up to date",
  CLOSED: "Closed",
  NONE: "N/A",
};

export const LINE_ITEMS_ERROR_UI_STRING_PATH = 'orderDetails.tabs.itemsRequested.banners.errors';
export const ACTIONS = "Actions";